import {useMemo} from 'react'
import {useAuthState} from 'react-firebase-hooks/auth'
import {auth} from 'configs/firebase'
import useUserQuery from './useUserQuery'

export default function useUser() {
  const {initialising, user: authUser} = useAuthState(auth)
  const {error, loading, value: dbUser} = useUserQuery(authUser && authUser.uid)

  const isLoading =
    initialising ||
    loading ||
    (authUser !== null && typeof dbUser === 'undefined')

  return useMemo(
    () => ({error, loading: isLoading, authUser, dbUser}),
    [error, isLoading, authUser, dbUser]
  )
}
